import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Link } from '@alfa-bank/site-link';
import { Hr } from '@alfa-bank/site-hr';
import { List } from '@alfa-bank/site-lists';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Img } from '@alfa-bank/site-img';

import type { TMarkdownContainerDesktop, IDepsDesktop } from '../models';
import { MarkdownContainer as Component } from '../layout/default';
import { configDesktop as config } from '../config';

import styles from './styles.css';

export const MarkdownContainerV2Desktop = createWidget<IDepsDesktop, TMarkdownContainerDesktop>({
    Text,
    Link,
    Img,
    Hr,
    List,
    Block,
    config,
    styles,
})(Component);
